(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-channel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPickers = (root = document) => {
      const pickers = [...root.querySelectorAll('[data-custom-picker]')];

      const getOptions = (picker) => [...picker.querySelectorAll('[data-picker-option]')];
      const refreshOptionVisibility = (picker) => {
        const options = getOptions(picker);
        options.forEach((option) => {
          option.hidden = false;
          option.classList.remove('is-hidden-current');
        });
        const selected = options.find((option) => option.getAttribute('aria-selected') === 'true');
        if (selected) {
          selected.hidden = true;
          selected.classList.add('is-hidden-current');
        }
      };

      const closeMenu = (picker) => {
        const list = picker.querySelector('[data-picker-list]');
        const trigger = picker.querySelector('[data-picker-trigger]');
        if (!list || !trigger) {
          return;
        }
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      const openMenu = (picker) => {
        const list = picker.querySelector('[data-picker-list]');
        const trigger = picker.querySelector('[data-picker-trigger]');
        if (!list || !trigger) {
          return;
        }
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      };

      const applySelection = (picker, option) => {
        const hiddenField = picker.querySelector('[data-picker-hidden]');
        const triggerLabel = picker.querySelector('[data-picker-trigger-label]');
        const triggerIcon = picker.querySelector('[data-picker-trigger-icon]');
        const linkedInputSelector = picker.dataset.linkedInputSelector;
        const options = getOptions(picker);

        options.forEach((node) => {
          node.classList.remove('is-selected');
          node.setAttribute('aria-selected', 'false');
        });

        option.classList.add('is-selected');
        option.setAttribute('aria-selected', 'true');
        refreshOptionVisibility(picker);

        if (hiddenField) {
          hiddenField.value = option.dataset.value || '';
        }
        if (triggerLabel && option.dataset.label) {
          triggerLabel.textContent = option.dataset.label;
        }
        if (triggerIcon) {
          const optionIcon = option.querySelector('[data-picker-option-icon]');
          if (optionIcon) {
            triggerIcon.innerHTML = optionIcon.innerHTML;
          }
        }
        if (linkedInputSelector && option.dataset.inputType) {
          const linkedInput = picker.closest('form')?.querySelector(linkedInputSelector);
          if (linkedInput) {
            linkedInput.setAttribute('type', option.dataset.inputType);
          }
        }
      };

      pickers.forEach((picker) => {
        if (picker.dataset.pickerInitialized == 'true') {
          return;
        }
        picker.dataset.pickerInitialized = 'true';
        const trigger = picker.querySelector('[data-picker-trigger]');
        const list = picker.querySelector('[data-picker-list]');
        const options = getOptions(picker);
        if (!trigger || !list || options.length === 0) {
          return;
        }
        refreshOptionVisibility(picker);

        trigger.addEventListener('click', () => {
          const isOpen = !list.hidden;
          if (isOpen) {
            closeMenu(picker);
            return;
          }
          openMenu(picker);
        });

        options.forEach((option) => {
          option.addEventListener('click', () => {
            applySelection(picker, option);
            closeMenu(picker);
            trigger.focus();
          });
        });
      });

    };

    initPickers(document);
    document.addEventListener('click', (event) => {
      const pickers = [...document.querySelectorAll('[data-custom-picker]')];
      pickers.forEach((picker) => {
        const list = picker.querySelector('[data-picker-list]');
        const trigger = picker.querySelector('[data-picker-trigger]');
        if (!list || !trigger) {
          return;
        }
        if (!picker.contains(event.target)) {
          list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('shopify:section:load', (event) => {
      initPickers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plant-tags-list-v2"] && !Shopify.designMode) return;
  try {
    
  // Mutates baseSet so it only contains values that also exist in otherSet.
  const intersectSets = (baseSet, otherSet) => {
    for (const value of Array.from(baseSet)) {
      if (!otherSet.has(value)) {
        baseSet.delete(value);
      }
    }
    return baseSet;
  };

  const initializePlantTagsFilterForm = (form) => {
    // Guard against duplicate initialization (theme editor can re-render sections).
    if (!form || form.dataset.plantTagsFilterInitialized === 'true') {
      return;
    }

    form.dataset.plantTagsFilterInitialized = 'true';

    const checkboxes = Array.from(form.querySelectorAll('.plant-tags-filter__checkbox'));
    const productsByTag = new Map();

    // Build an in-memory index: tag gid -> set of product ids carrying that tag.
    checkboxes.forEach((checkbox) => {
      const productIds = (checkbox.dataset.productIds || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
      productsByTag.set(checkbox.value, new Set(productIds));
    });

    const recalculateDisabledStates = () => {
      // Current filter state is driven by checked checkboxes.
      const checkedValues = checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value);

      checkboxes.forEach((checkbox) => {
        const item = checkbox.closest('.plant-tags-filter__item');
        if (!item) {
          return;
        }

        if (checkbox.checked) {
          // Always keep selected options enabled so users can uncheck them.
          checkbox.disabled = false;
          item.classList.remove('plant-tags-filter__item--disabled');
          return;
        }

        // Candidate starts with all products for that tag.
        const candidateProducts = new Set(productsByTag.get(checkbox.value) || []);
        let isActive = candidateProducts.size > 0;

        // AND logic: candidate must intersect with every selected tag set.
        for (const selectedValue of checkedValues) {
          const selectedProducts = productsByTag.get(selectedValue) || new Set();
          intersectSets(candidateProducts, selectedProducts);
          if (candidateProducts.size === 0) {
            isActive = false;
            break;
          }
        }

        checkbox.disabled = !isActive;
        item.classList.toggle('plant-tags-filter__item--disabled', !isActive);
      });
    };

    form.addEventListener('change', (event) => {
      // Recompute instantly when any checkbox is toggled.
      if (!event.target.closest('.plant-tags-filter__checkbox')) {
        return;
      }
      recalculateDisabledStates();
    });

    // Ensure correct initial state on first paint.
    recalculateDisabledStates();
  };

  // Support multiple instances of this section on a page.
  document.querySelectorAll('.plant-tags-filter__form').forEach(initializePlantTagsFilterForm);

  } catch(e) { console.error(e); }
})();
})();
